import store from '@/store'
import router from '@/router'
import { $langt } from '@/utils/i18n'
import { iso639_1 } from '@/utils/iso639_1'

export function getStoreCode() {
  if (process.env.VUE_APP_CHANNEL_CODE) {
    return process.env.VUE_APP_CHANNEL_CODE
  } else {
    const domain = new URL(window.location.href || document.location.href)
      .hostname
    const part1 = domain.split('.')[0]
    const part2 = part1.split('-')
    if (part2[1] !== undefined) {
      return part2[1]
    } else {
      return part2[0]
    }
  }
}
// 判斷正式或測試 happygo用
export function getEnv() {
  const domain = new URL(window.location.href || document.location.href)
    .hostname
  const part1 = domain.split('.')[0]
  if (part1.indexOf('-') !== -1 || part1 === domain) {
    return 'DEV'
  } else {
    return 'PROD'
  }
}

// 取得目前環境
export function getENVtype() {
  const urlInfo = new URL(window.location.href || document.location.href)
  const { hostname } = urlInfo

  if (hostname.startsWith('alex-') || hostname === 'localhost') {
    return 'dev'
  }

  if (hostname.startsWith('qa-')) {
    return 'qa'
  }

  return 'prod'
}

export function getApiUrl(nochannel) {
  // return 'https://test.opencube.tw/' + getStoreCode()
  const urlInfo = new URL(window.location.href || document.location.href)
  const domain = urlInfo.hostname
  const storeCode = nochannel ? '' : '/' + getStoreCode()
  if (domain === 'localhost' || domain.indexOf('192') !== -1) {
    return process.env.VUE_APP_BASE_API_DEV + storeCode
  } else {
    return (
      urlInfo.protocol +
      '//' +
      domain.replace(getStoreCode() + '.', 'api.') +
      storeCode
    )
  }
}

export function getImgUrl() {
  // return 'https://test.opencube.tw/' + getStoreCode()
  const urlInfo = new URL(window.location.href || document.location.href)
  const domain = urlInfo.hostname
  // const part1 = domain.split('.')[0]
  // const part2 = part1.split('-')
  if (domain === 'localhost' || domain.indexOf('192') !== -1) {
    return 'https://alex-img.3tet.com'
  } else {
    return (
      urlInfo.protocol + '//' + domain.replace(getStoreCode() + '.', 'img.')
    )
  }
}
export function getSSOUrl() {
  const partnername = getStoreCode().toLocaleUpperCase()
  const str = `VUE_APP_${partnername}_URL_` + getEnv()
  return process.env[str]
}

export function getHappyGoUrl() {
  const str = 'VUE_APP_HAPPYGO_URL_' + getEnv()
  return process.env[str]
}

export function getHappyGoSiteCoode() {
  const str = 'VUE_APP_HAPPYGO_SITE_CODE_' + getEnv()
  return process.env[str]
}

export function getTwmOauthUrl() {
  const str = 'VUE_APP_TWM_OAUTH_URL_' + getENVtype().toUpperCase()
  return process.env[str]
}

export function toErrorPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/error' }, () => {})
}

export function showNotice(message, func, close) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close
  }
  store.commit('SET_NOTICE_MESSAGE', data)
}

export function showCusNotice(message, url, func, close) {
  const data = {
    message: message,
    url: url,
    func: func,
    close: close === undefined ? true : close
  }
  store.commit('SET_CUS_NOTICE', data)
}

export function showConfirm(message, func, cancelFunc, warning, btn) {
  if (typeof func === 'function') {
    const confirm = {
      message: message,
      func: func,
      cancelFunc: cancelFunc,
      warning: warning,
      btn: btn
    }
    store.commit('SET_CONFIRM_DIALOG', confirm)
  }
}

export function showFirstLoginConfirm(
  message,
  submessage,
  submessage2,
  func,
  cancelFunc
) {
  if (typeof func === 'function') {
    const confirm = {
      message: message,
      submessage: submessage,
      submessage2: submessage2,
      func: func,
      cancelFunc: cancelFunc
    }
    store.commit('SET_FIRSTLOGINCONFIRM_DIALOG', confirm)
  }
}

export function setCateClass(cate_id) {
  cate_id = cate_id + ''
  switch (cate_id) {
    case '1':
      return 'eating_item'
    case '2':
      return 'hotspring_color'
    case '3':
      return 'living_item'
    case '4':
      return 'spa_item'
    case '5':
      return 'amusement_item'
    case '6':
      return 'traffic_item'
    case '7':
      return 'wifi_sim_item'
    case '8':
      return 'travil_item'
    default:
      return 'allitem_color'
  }
}

export function happyGoTimeNotice() {
  var date = new Date()

  var minutes = date.getMinutes()
  var hour = date.getHours()

  if ((hour === 23 && minutes >= 50) || (hour === 0 && minutes <= 10)) {
    showNotice($langt('提醒\r\n 23:50 ~ 00:10 無法使用Happygo點數'))
  }
}

export function checkPlatform() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  if (/android/i.test(userAgent)) {
    return 'android'
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios'
  }

  return 'web'
}

export function getStoreappurl() {
  const str =
    'VUE_APP_' + getStoreCode().toLocaleUpperCase() + '_URL_' + getEnv()

  return process.env[str]
}

export function loadCSSbystore() {
  const file = document.createElement('link')
  file.rel = 'stylesheet'
  const domain = new URL(window.location.href || document.location.href)
    .hostname
  const part1 = domain.split('.')[0]
  const csssrc = 'mall_' + getStoreCode() + '.css' + '?v=' + new Date().getTime()
  if (part1.indexOf('-') !== -1 || part1 === domain) {
    if (part1.indexOf('qa-') !== -1) {
      file.href = 'https://qa-img.3tet.com/upload/assets/' + csssrc
    } else {
      file.href = 'https://alex-img.3tet.com/upload/assets/' + csssrc
    }
  } else {
    file.href = 'https://img.3tet.com/upload/assets/' + csssrc
  }
  document.head.appendChild(file)
  // load common css themes 載入共用
  const commonthemesfile = document.createElement('link')
  commonthemesfile.rel = 'stylesheet'
  commonthemesfile.href = '/Scripts/commonthemes.css' + '?v=' + new Date().getTime()
  document.head.appendChild(commonthemesfile)
}

// 設定 Title 資訊
export const getTitle = val => {
  const title =
    store.getters.shopInfo && store.getters.shopInfo.title
      ? `${store.getters.shopInfo.title}`
      : $langt('3TET 電票通')

  let str = ''
  if (!val) {
    str = title
  } else {
    str = `${val} | ${title}`
  }

  const env = getENVtype()
  if (env === 'dev' || env === 'qa') {
    str += ` (${env.toUpperCase()})`
  }

  document.title = str
}

function pad(v) {
  return v < 10 ? '0' + v : v
}
// get date formta yyyyMMddHHmmss
export const getDateFormat = d => {
  var year = d.getFullYear()
  var month = pad(d.getMonth() + 1)
  var day = pad(d.getDate())
  var hour = pad(d.getHours())
  var min = pad(d.getMinutes())
  var sec = pad(d.getSeconds())
  return year + month + day + hour + min + sec
}

// 預設路徑對應的語系
var mallDefaultLangcode = ''
var mallAllowLangcode = []

/**
 * 檢查語系是否合法。此處判斷忽略大小寫
 * 支援 'zh' , 'zh-CN' 及 例外 'tw'
 * @param {string} langcode
 * @return {boolean}
 */
export function legalLangCode(langcode) {
  // 轉為全小寫進行處理 //
  const code = langcode.toLowerCase()
  if (code.length === 2) {
    // 台灣是例外 //
    return (code === 'tw') || iso639_1.includes(code)
  }
  if (code.length >= 3 && code.substring(2, 3) === '-') {
    return iso639_1.includes(code.substring(0, 2))
  }
  return false
}

export function setDefaultLangcode(langcode) {
  mallDefaultLangcode = langcode
}

/**
 * 儲存此商店支援的 langcode
 * @param {Array} langcodes
 */
export function setAllowLangcode(langcodes) {
  mallAllowLangcode = langcodes
}

export function defaultLangcode() {
  return mallDefaultLangcode
}

/**
 * 從 langPath 反轉出對應的 Langcode
 * @param { string } langPath
 * @return { string | null } 沒有找到回傳 null
 */
export function langPathToLangcode(langPath) {
  for (let i = 0; i < mallAllowLangcode.length; i++) {
    if (langPath.toLowerCase() === mallAllowLangcode[i].lang_code.toLowerCase()) {
      return mallAllowLangcode[i].lang_code
    }
  }
  return null
}

// 目前URL路徑上，對應的語系段落。沒有指定語系段落，回應空字串
export function getLangPath() {
  const urlPart1 = new URL(window.location.href).pathname.split('/')[1]
  return legalLangCode(urlPart1) ? urlPart1 : ''
}

// 取得現在路徑的 langcode
export function getLangcode() {
  return getLangPath() === '' ? defaultLangcode() : langPathToLangcode(getLangPath())
}

// 檢查路徑上的 langcode 是否合法，或直接修正。 langs 為支援的語系
export function validateLangPath(langcode, langs) {
  if (langs) {
    // 已取得廠商可以使用的語系 //
    for (let index = 0; index < langs.length; index++) {
      if (langs[index].lang_code === langcode) {
        return true
      }
    }
    return false
  }
  // 沒有限制使用語系，都放行 //
  return true
}

// 計算一個路徑 更改語系後 的路徑 //
export function pathWithLangPath(path, langPath) {
  const url = new URL(path)
  // 如果有語系，先刪除 //
  const part1 = url.pathname.split('/')[1]
  if (legalLangCode(part1)) {
    url.pathname = (url.pathname.length === (part1.length + 1)) ? '/'
      : url.pathname.substring(part1.length + 1)
  }
  if (langPath) {
    url.pathname = '/' + langPath + url.pathname
  }
  return url.toString()
}

// 計算是否可以退貨 //
export function storeRefundable() {
  // return getStoreCode() !== 'oppaylater'
  return true
}

// 依照廠商，取得預設的地區選單ID //
export function getDefaultAreaId() {
  switch (getStoreCode()) {
    // 台灣 //
    case 'oppaylater': return 5000
  }
  return 0
}
